import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import AppRoutes from "./routes/AppRoutes";
import AuthProvider from "./auth/AuthProvider";
import Login from "./pages/Login";
import AboutProduct from "./pages/About/AboutProduct";
import { getOrganizationConfig } from "./utils/organizationConfig";
import { initializeTenantResolver } from "./services/tenantResolver";

function App() {
  const location = useLocation();

  // Update document metadata with dynamic organization information
  useEffect(() => {
    const updateMetadata = async () => {
      try {
        // Initialize tenant resolver (for pre-login scenarios)
        initializeTenantResolver();

        // Initialize organization config with dynamic tenant data
        const organizationConfig = getOrganizationConfig();
        await organizationConfig.initialize();

        // Get metadata with dynamic organization name
        const metadata = organizationConfig.getMetadata();
        const favicon = organizationConfig.getFavicon();

        // Update document title
        document.title = metadata.title || 'Inferno - The Most Advanced Fire Safety Management System';

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', metadata.description || 'The Most Advanced Fire Safety Management Software');
        }

        // Update favicon (uses logoURL if available)
        const faviconLink = document.querySelector('link[rel="icon"]');
        if (faviconLink) {
          faviconLink.setAttribute('href', favicon || '/inferno-logo.png');
        }
      } catch (error) {
        console.error('Failed to update metadata:', error);
        // Fallback title
        document.title = 'Inferno - The Most Advanced Fire Safety Management System';
      }
    };

    updateMetadata();
  }, []);

  // Define public routes that don't require authentication
  const publicRoutes = ['/', '/about'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  console.log('[App] Render:', {
    pathname: location.pathname,
    isPublicRoute,
    willRenderAppRoutes: !isPublicRoute
  });

  return (
    <AntdApp>
      <AuthProvider>
        {isPublicRoute ? (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/about" element={<AboutProduct />} />
          </Routes>
        ) : (
          <AppRoutes />
        )}
      </AuthProvider>
    </AntdApp>
  );
}

export default App;
